export default [
  {
    path: "/maintenance/products",
    name: "products",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "ITEMS_TITLE"
    },
    component: () =>
      import(/* webpackChunkName: "ProductView" */ "./ProductView/ProductView.vue")
  },
  {
    path: "/maintenance/archived-products",
    name: "archived-products",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "ARCHIVED_PRODUCTS_TITLE"
    },
    component: () =>
      import(/* webpackChunkName: "ArchivedProductsView" */ "./ProductView/ArchivedProductsView.vue")
  },
  {
    path: "/maintenance/locations",
    name: "locations",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "LOCATIONS_TITLE"
    },
    component: () =>
      import(/* webpackChunkName: "forecasts" */ "./locations/Locations.vue")
  },
  {
    path: "/maintenance/sites",
    name: "sites",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "SITES_TITLE"
    },
    component: () =>
      import(/* webpackChunkName: "sites" */ "./sites/Sites.vue")
  },
  {
    path: "/maintenance/sites-location",
    name: "sites-location",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "SITES_LOCATION_TITLE"
    },
    beforeEnter: (to, from, next) => {
      // Check for required siteId parameter at route level
      if (!to.params.siteId) {
        next({ name: "sites" });
      } else {
        next();
      }
    },
    component: () =>
      import(/* webpackChunkName: "SiteLocations" */ "./sites/SiteLocations.vue")
  },
  {
    path: "/maintenance/deviceTypes",
    name: "deviceTypes",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "DEVICE_TYPES_TITLE"
    },
    component: () =>
      import(/* webpackChunkName: "deviceTypes" */ "./deviceTypes/DeviceTypes.vue")
  },
  {
    path: "/maintenance/costCenters",
    name: "costCenters",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "COST_CENTERS_TITLE"
    },
    component: () =>
      import(/* webpackChunkName: "costCenters" */ "./costCenters/CostCenters.vue")
  },
  {
    path: "/maintenance/productStates",
    name: "productStates",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "PRODUCT_STATES_TITLE"
    },
    component: () =>
      import(/* webpackChunkName: "productStates" */ "./productStates/ProductStates.vue")
  },
  {
      path: "/maintenance/import",
      name: "import",
      meta: {
        permissions: {
          roles: ["office", "administrator", "superadmin"],
          redirectTo: "/401"
        },
        title: "Betöltés"
      },
      component: () =>
        import(/* webpackChunkName: "forecasts" */ "./import/ImportExportView.vue")
  },
];
